import { render } from "./AiProfiler.vue?vue&type=template&id=b29c47fc&scoped=true"
import script from "./AiProfiler.vue?vue&type=script&lang=js"
export * from "./AiProfiler.vue?vue&type=script&lang=js"

import "./AiProfiler.vue?vue&type=style&index=0&id=b29c47fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b29c47fc"]])

export default __exports__